import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../services/order.service';
import {Order} from '../../../models/Order/Order';
import {ProductDataSet} from '../../../models/product-data-set';
import {Product} from '../../../models/product';
import {ProductService} from '../../../services/product.service';
import {RegistryService} from "../../../services/registry.service";

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {

  id: string ;
  order: Order[] = [];
  dataset: ProductDataSet;
  skuArr: any[] = [];
  Products: Product[] = [];

  constructor(private route: ActivatedRoute ,
              private registry: RegistryService,
              private orderService: OrderService , private router: Router, private productService: ProductService) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') ;
    if (this.id) {
      this.getOrderDetails(this.id);
    }
  }

  getOrderDetails(id) {
    this.orderService.getOrderDetails(id).subscribe(data => {
      this.order = data;

      for (let i = 0 ; i < this.order[0].items.length ; i++) {
        this.skuArr[i] = this.order[0].items[i].sku;
      }

      this.getProductsDetails();
    });

  }

  goToProductDetails(sku) {
    this.router.navigateByUrl('product/details/' + sku);


  }

  getProductsDetails() {
    this.dataset = new ProductDataSet();
    this.dataset.pushParams('sku', this.skuArr, 'in');
    this.fetchProductDataSet();

  }

  fetchProductDataSet() {

    return this.productService.getProductDataSet(this.dataset.getDataSetParams(this.registry.getWebsiteId())).subscribe((data: any) => {
      // console.log('the url ' + url);
      this.Products = data.items.map(item => Object.assign(new Product(), item));
    });

  }

}
